/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TokenVesting,
  TokenVestingInterface,
} from "../../contracts/TokenVesting";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Released",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "Revoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "ScheduleCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "computeReleasableAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_cliff",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_slicePeriodSeconds",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_revocable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "createVestingSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_beneficiaries",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "_start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_cliff",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_slicePeriodSeconds",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_revocable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "createVestingSchedules",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getReservesBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "getVestingScheduleById",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "beneficiary",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "slicePeriodSeconds",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "revocable",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amountTotal",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "released",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "revoked",
            type: "bool",
          },
        ],
        internalType: "struct TokenVesting.VestingSchedule",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVestingSchedules",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "beneficiary",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "slicePeriodSeconds",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "revocable",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amountTotal",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "released",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "revoked",
            type: "bool",
          },
        ],
        internalType: "struct TokenVesting.VestingSchedule[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "getVestingSchedulesByBeneficiary",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "beneficiary",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "slicePeriodSeconds",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "revocable",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amountTotal",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "released",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "revoked",
            type: "bool",
          },
        ],
        internalType: "struct TokenVesting.VestingSchedule[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVestingSchedulesCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
    ],
    name: "getVestingSchedulesCountByBeneficiary",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
    ],
    name: "getVestingSchedulesIdsByBeneficiary",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getVestingSchedulesTotalAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "getVestingSchedulesWithReleasableAmountByBeneficiary",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "address",
                name: "beneficiary",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "cliff",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "start",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "duration",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "slicePeriodSeconds",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "revocable",
                type: "bool",
              },
              {
                internalType: "uint256",
                name: "amountTotal",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "released",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "revoked",
                type: "bool",
              },
            ],
            internalType: "struct TokenVesting.VestingSchedule",
            name: "schedule",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "releaseAmount",
            type: "uint256",
          },
        ],
        internalType: "struct TokenVesting.VestingScheduleWithReleaseAmount[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "vestingPoolAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vestingScheduleId",
        type: "uint256",
      },
    ],
    name: "revoke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "updateVestingPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TokenVestingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TokenVestingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TokenVesting__factory extends ContractFactory {
  constructor(...args: TokenVestingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<TokenVesting> {
    return super.deploy(overrides || {}) as Promise<TokenVesting>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TokenVesting {
    return super.attach(address) as TokenVesting;
  }
  override connect(signer: Signer): TokenVesting__factory {
    return super.connect(signer) as TokenVesting__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TokenVestingInterface {
    return new utils.Interface(_abi) as TokenVestingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TokenVesting {
    return new Contract(address, _abi, signerOrProvider) as TokenVesting;
  }
}
